import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

import { backgroundGradient } from "../../../common/materials/LinearGradient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { StyledCardContainer } from "../../../common/materials/GenericStyleComponent";
import IRouterComponentProps from "../../../models/IRouterComponentProps";
import EllipsisText from "../../../common/elements/EllipsisText";
import ProductDescription from "../../shared/ProductDescription";
import ReactPlayer from "react-player";
import {
  makeLinkClickable,
  openCertificateLinkPopup,
} from "../../../common/GenericFunctions";
import AlertReadOnlyUser from "../../../common/elements/AlertReadOnlyUser";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Checkbox, useMediaQuery, useTheme } from "@material-ui/core";
import PreviewPrebiding from "./bulkWatchlistComponent/PreviewPrebiding";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import ParcelProductDescription from "../../shared/ParcelProductDescription";

const faHeartProps = faHeart as IconProp;

const StyledTitleWrapper = styled(Grid)`
  background: ${backgroundGradient};
  display: flex;
  align-items: center;
  height: 100px;
  font-size: 0.8em;
  color: ${(props) => props.theme.colors.base.white};

  .height {
    height: 100%;
  }
`;

const StyledWishContainer = styled(Grid)`
  background: ${backgroundGradient};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  position: relative;
`;

const StyledNotStartedContainer = styled(Grid)`
  cursor: default;
  background: ${(props) => props.theme.colors.base.lightGrey};
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
  }
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
`;

const StyledProductImageContainer = styled(Grid)`
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  position: relative;
`;

const StyledTotalSubProducts = styled.div`
  position: absolute;
  bottom: 0;
  background: ${(props) => props.theme.colors.base.lightGrey};
  width: 100%;
  text-align: center;
  opacity: 0.5;
  color: ${(props) => props.theme.colors.base.black};
`;

const StyledProductImage = styled("img")`
  max-width: 100%;
  max-height: 100%;
`;

const StyledWrapper = styled(Grid)`
  padding: 5px;
  padding-top: 5px;
  color: ${(props) => props.theme.colors.base.buttonGradientFirstColor};
  text-align: center;
`;

const StyledLabelWrapper = styled.div`
  text-align: center;
  font-size: 1em;
`;

export const StyledRapOffLabelWrapper = styled.div`
  font-size: 0.8em;
  justify-content: center;
`;

const StyledSerialNumberLabelWrapper = styled.div`
  text-align: center;
  font-size: 1em;
  cursor: pointer;
`;

const StyledValueConatiner = styled.div`
  text-align: center;
  font-size: 1em;
`;

const StyledBidAmount = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledPrebidBidAmount = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const StyledRemarks = styled(Grid)`
  display: flex;
  align-items: end;
  margin-left: 6px;
`;

const StyledRemarkLbl = styled.div`
  margin-left: 0.2em;
  display: flex;
`;

const StyledContainer = styled(Grid)``;

const StyledProductCon = styled(Grid)`  
  border-bottom: 1px solid ${(props) => props.theme.colors.base.white};
  .marginLeft {
    margin-left: 1%px;
  }

  .padding {
    padding: 0.2em;
    font-size: 1.2em;
  }
  .alignCenter {
    text-align: center;
  }
  .marginRight {
    border-right: 1px solid ${(props) => props.theme.colors.base.white};
  }
  .alignRight {
    text-align: right;
  }
`;

const StyledDescription = styled(Grid)`
  padding: 0.2em;
  margin-top: 0.8em;
  widht: 100%;
  display: -webkit-box;
  max-width: 500px;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledContDaimond = styled.div`
  padding: 0.1em;
  font-size: 1.2em;
  @media (max-width: 1378px) {
    font-size: 1.1em;
    padding: 0.1em;
  }
`;


const StyledDescriptionContainer = styled.div`
  display: -webkit-box;
  max-width: 500px;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface IProps extends IRouterComponentProps {
  t: any;
  perId: string;
  auctionId: string;
  serialNo: string | number;
  code: string;
  carat: string;
  color: string;
  clarity: string;
  cutGrade: string;
  flour: string;
  polish: string;
  watched: boolean | null;
  polishAbbreviation: string;
  symmetry: string;
  lab: string;
  certificate: string;
  caratMinimumPrice: any;
  preBidPrice: any;
  showAlert: any;
  note: boolean | null | string | number;
  addToWatchList: any;
  removeFromWatchlist: any;
  medias: any;
  auctionDate: any;
  remarks: string;
  parcelType: string;
  subItems: [];
  shape: string;
  sieve: string;
  noOfPieces: number | string | null;
  productDescription: string;
  currency: any;
  exchangeRates: any;
  auctionState: any;
  items: any;
  sellerAuctionUserId: string;
  auctionUserId: string;
  rapnetPercentage: any;
  sortingValue: (price: any, val: any) => void;
  index: number;
  selectedExportId: any[];
  selectItemInGridView: (x: any) => void;
  prebidCall: any;
}

let caratMinPrice: string = "";
let bidAmount: string = "";
let state: string | null = "";
let conversionCaratMinPrice: string = "";
let conversionBidAmount: string = "";
let direction: string = "desc";
let isReadOnlyUser: any;
let isSellerAuctionUserId: any;

const initialState = {
  mouseX: null,
  mouseY: null,
};
let sourceFromUrl: any;
let auctioneerId: any;
let auctioneerSellerUserId: any = "";
const ProductsListGrid = (props: IProps) => {
  const [isAuctionUserId, setIsAuctionUserId] = useState(false);
  const [openReadOnlyUserToast, setOpenReadOnlyUserToast] = useState(false);
  const [isSort, setIsSort] = useState(false);
  const [mouseState, setMouseState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);

  let {
    t,
    index,
    auctionDate,
    medias,
    watched,
    serialNo,
    perId,
    auctionId,
    code,
    carat,
    caratMinimumPrice,
    preBidPrice,
    remarks,
    parcelType,
    subItems,
    noOfPieces,
    currency,
    exchangeRates,
    sellerAuctionUserId,
    rapnetPercentage,
    lab,
    certificate,
    selectedExportId,
    selectItemInGridView,
    items,
    prebidCall,
    productDescription,
  } = props;

  caratMinPrice = new Intl.NumberFormat("us-en").format(caratMinimumPrice);
  bidAmount = new Intl.NumberFormat("us-en").format(preBidPrice);
  let isClickableRemark: any = makeLinkClickable(
    parcelType === "Parcel" ? productDescription : remarks
  );
  const isMobile = useMediaQuery("(max-width: 1378px)");

  useEffect(() => {
    localStorage.setItem("WatchlistParcelType", parcelType);
    caratMinPrice = "";
    bidAmount = "";
    var joinedAuctions: any = localStorage.getItem("joinedAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any) => {
        if (items.perId === auctionId) {
          auctioneerSellerUserId = items.auctionUserId;
        }
        if (sellerAuctionUserId === items.auctionUserId) {
          setIsAuctionUserId(true);
        } else {
          setIsAuctionUserId(false);
        }
      });
    } else {
      setIsAuctionUserId(false);
    }
    isReadOnlyUser = localStorage.getItem("isReadOnlyUser");
    isReadOnlyUser = JSON.parse(isReadOnlyUser);
    const urlParams = new URLSearchParams(window.location.search);
    sourceFromUrl = urlParams.get("source");
    return () => {
      localStorage.removeItem("pathname");
      setIsAuctionUserId(false);
    };
  }, []);

  if (
    caratMinimumPrice === null ||
    caratMinPrice === "NaN" ||
    caratMinPrice === "0"
  ) {
    caratMinPrice = "-";
  } else {
    let userCurrencyCode = localStorage.getItem("preferredCurrency");
    let userCurrencySymbol = localStorage.getItem("preferredCurrencySymbol");
    if (userCurrencyCode !== currency["code"]) {
      let conversionPrice = new Intl.NumberFormat("us-en").format(
        Math.round(caratMinimumPrice * exchangeRates[0]["rate"])
      );
      conversionCaratMinPrice = `(${userCurrencySymbol}${conversionPrice})`;
    } else {
      conversionCaratMinPrice = "";
    }
    caratMinPrice = `${currency["symbol"]}${caratMinPrice}`;
  }

  if (preBidPrice === null || bidAmount === "NaN" || bidAmount === "0") {
    bidAmount = "-";
    conversionBidAmount = "";
  } else {
    let userCurrencyCode = localStorage.getItem("preferredCurrency");
    let userCurrencySymbol = localStorage.getItem("preferredCurrencySymbol");
    if (userCurrencyCode !== currency["code"]) {
      let conversion = new Intl.NumberFormat("us-en").format(
        Math.round(preBidPrice * exchangeRates[0]["rate"])
      );
      conversionBidAmount = `(${userCurrencySymbol}${conversion})`;
    } else {
      conversionBidAmount = "";
    }
    bidAmount = `${currency["symbol"]}${bidAmount}`;
  }

  if (state !== null) {
    state = localStorage.getItem("auctionState");
  }

  const onPress = (auctionId: string, perId: string, auctionDate: string) => {
    if (sourceFromUrl === "admin") {
      props.history.push(
        `/preview/details/${auctionId}/${perId}/${auctionDate}?redirectFromPreview=true`
      );
    } else {
      props.history.push(
        `/preview/details/${auctionId}/${perId}/${auctionDate}`
      );
    }
  };

  const openDetailsView = (
    auctionId: string,
    perId: string,
    auctionDate: string
  ) => {
    const language = localStorage.getItem("language");

    const languageCode =
      language === "EN" ? "en" : language === "zh_CN" ? "zh_CN" : "jp";

    if (sourceFromUrl === "admin") {
      window.open(
        `/${languageCode}/preview/details/${auctionId}/${perId}/${auctionDate}?redirectFromPreview=true`,
        "_blank"
      );
    } else {
      window.open(
        `/${languageCode}/preview/details/${auctionId}/${perId}/${auctionDate}`,
        "_blank"
      );
    }
  };

  const ShowImage = () => {
    for (let i = 0; i < medias.length; i++) {
      let mediaItem = medias[i];
      if (mediaItem.mediaType === "PHOTO") {
        if (mediaItem.primary === true) {
          medias.splice(i, 1);
          medias.unshift(mediaItem);
          break;
        }
      }
    }
    return <StyledProductImage src={`${medias[0].presignedUrl}`} alt="" />;
  };

  const addProductToWatch = () => {
    props.addToWatchList(perId, auctionId, serialNo);
  };

  const removeProductFromList = () => {
    props.removeFromWatchlist(perId, auctionId);
  };

  const PlayerSlide = ({ url }: { url: string }) => (
    <ReactPlayer
      width="100%"
      height="100%"
      url={url}
      playing={false}
      controls={true}
      muted={true}
      progressInterval={1000}
      config={{
        file: {
          attributes: {
            controlsList: "nofullscreen",
          },
        },
      }}
    />
  );

  const sortingFuction = (price: any, value: any) => {
    props.sortingValue(price, value);
    if (value === "desc") {
      direction = "asc";
    } else {
      direction = "desc";
    }
    setIsSort(!isSort);
  };

  const renderReadOnlyUserToast = async (id: any) => {
    var joinedAuctions: any = localStorage.getItem("joinedAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any) => {
        if (id === items.auctionUserId) {
          isSellerAuctionUserId = true;
        }
      });
    } else {
      isSellerAuctionUserId = false;
    }
    await renderPopup();
  };

  const renderPopup = () => {
    if (isReadOnlyUser) {
      setOpenReadOnlyUserToast(true);
    } else if (isSellerAuctionUserId) {
      setOpenReadOnlyUserToast(true);
    } else {
      setOpenReadOnlyUserToast(false);
    }
    setTimeout(() => {
      setOpenReadOnlyUserToast(false);
    }, 3000);
  };

  const rightClickEvent = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setMouseState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleClose = () => {
    setMouseState(initialState);
  };

  const checkBoxrender = () => {
    return (
      <>
        {" "}
        {isReadOnlyUser ? (
          <Checkbox
            id={perId}
            name={perId}
            checked={selectedExportId.indexOf(index) !== -1}
            color="primary"
            disabled
            style={{ color: "grey" }}
            inputProps={{ "aria-label": "uncontrolled-checkbox" }}
          />
        ) : (
          <Checkbox
            id={perId}
            name={perId}
            checked={selectedExportId.indexOf(index) !== -1}
            color="primary"
            style={{ color: "white" }}
            value={index}
            inputProps={{ "aria-label": "uncontrolled-checkbox" }}
            onChange={(e) => {
              selectItemInGridView(index);
            }}
          />
        )}
      </>
    );
  };

  const videoLinkrender = () => {
    if (isClickableRemark !== false) {
      return (
        <span
          title="Video Link"
          style={{ color: "white", cursor: "pointer" }}
          onClick={() => {
            window.open(
              isClickableRemark,
              "DescriptiveWindowName",
              "height=700px,width=1024px,scrollbars,toolbar,status,resizable"
            );
          }}
        >
          <PlayCircleOutlineIcon fontSize={"small"} />
        </span>
      );
    } else {
      return;
    }
  };

  let mediaSection = useMemo(() => {
    if (
      medias !== null ||
      medias !== undefined ||
      medias[0] !== undefined ||
      medias[0] !== null
    ) {
      let index = medias.findIndex((obj: any) => obj.primary === true);
      if (index !== -1) {
        let primaryObj = medias.splice(index, 1)[0];
        medias.unshift(primaryObj);
      }
    }
    return (
      <StyledProductImageContainer
        item={true}
        xs={9}
        onClick={() => onPress(auctionId, perId, auctionDate)}
      >
        {medias === null ||
          medias === undefined ||
          medias[0] === undefined ||
          medias[0] === null ||
          medias[0].presignedUrl === null ||
          medias[0].mediaType === "V360" ? (
          <div>
            {parcelType === "Diamond" ? (
              <StyledProductImage src="/images/default-diamond.png"></StyledProductImage>
            ) : (
              <StyledProductImage src="/images/default-parcel.png"></StyledProductImage>
            )}
          </div>
        ) : (
          <>
            {medias[0].mediaType === "PHOTO" ? (
              <ShowImage />
            ) : (
              <div>
                {medias[0].mediaType.thumbnailPresignedUrl === null ||
                  medias[0].mediaType.presignedUrl === null ? (
                  <div>
                    {parcelType === "Diamond" ? (
                      <StyledProductImage src="/images/default-diamond.png"></StyledProductImage>
                    ) : (
                      <StyledProductImage src="/images/default-parcel.png"></StyledProductImage>
                    )}
                  </div>
                ) : (
                  <PlayerSlide url={`${medias[0].presignedUrl}`} />
                )}
              </div>
            )}
          </>
        )}
        <StyledTotalSubProducts>
          {subItems !== undefined && subItems.length > 0 && (
            <span>
              {subItems.length} {t("common:preview:products")}
            </span>
          )}
        </StyledTotalSubProducts>
      </StyledProductImageContainer>
    );
  }, [items]);

  return (
    <Grid>
      {perId !== undefined && (
        <StyledCardContainer
          id={serialNo.toString()}
          onContextMenu={rightClickEvent}
        >
          <Grid container={true} spacing={0} className="borderBottomBlue fontBold">
            <StyledTitleWrapper item={true} xs={10}>
              <Grid container={true} spacing={1} className="height">
                <Grid
                  item={true}
                  xs={2}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <>
                    {isReadOnlyUser ? (
                      <Checkbox
                        inputProps={{ "aria-label": "uncontrolled-checkbox" }}
                        disabled
                      />
                    ) : (
                      <>
                        {isAuctionUserId ? (
                          <Checkbox
                            inputProps={{
                              "aria-label": "uncontrolled-checkbox",
                            }}
                            disabled
                          />
                        ) : auctioneerSellerUserId === sellerAuctionUserId ? (
                          <Checkbox
                            inputProps={{
                              "aria-label": "uncontrolled-checkbox",
                            }}
                            disabled
                          />
                        ) : (
                          <>{checkBoxrender()}</>
                        )}
                      </>
                    )}
                  </>
                  <>{videoLinkrender()}</>
                </Grid>
                <Grid item={true} xs={10}>
                  {parcelType === "Diamond" ? (
                    <StyledDescriptionContainer
                      onClick={() => onPress(auctionId, perId, auctionDate)}
                    >
                      <StyledContDaimond>
                        <ProductDescription
                          truncateLength={isMobile ? 95 : 95}
                          data={props.items}
                          isTendor={false}
                        />
                      </StyledContDaimond>
                    </StyledDescriptionContainer>
                  ) : (
                    <StyledDescriptionContainer>
                      <StyledProductCon
                        item
                        spacing={0}
                        container
                        xs={12}
                        onClick={() => onPress(auctionId, perId, auctionDate)}
                      >
                        <Grid xs={6} item className="marginRight padding" style={{ fontSize: '0.9em' }}>
                          {code}
                        </Grid>
                        <Grid
                          xs={2}
                          item
                          className="marginRight padding alignCenter"
                          style={{ fontSize: '0.9em' }}
                        >
                          {noOfPieces === 0
                            ? "-"
                            : `${noOfPieces} ${t("common:preview:pieces")}`}
                        </Grid>
                        <Grid xs={4} item className="padding alignRight" style={{ fontSize: '0.9em' }}>
                          {carat === undefined ? "" : ` ${carat} ${"Ct"}`}
                        </Grid>
                      </StyledProductCon>

                      <StyledDescription item xs={12} className="padding" style={{ fontSize: '1.2em' }}>
                        <ParcelProductDescription
                          truncateLength={isMobile ? 88 : 90}
                          data={props.items}
                          isTendor={false}
                        />
                      </StyledDescription>
                    </StyledDescriptionContainer>
                  )}
                </Grid>
                <StyledRemarks item={true} xs={12}>
                  {parcelType === "Diamond" && (
                    <div style={{ display: 'flex', gap: 2, flexDirection: "row" }}>
                      <span style={{ fontSize: '1.1em' }}>
                        {t("common:preview:perItemDescription:remarks") + ": "} {" "}
                      </span>
                      <StyledRemarkLbl style={{ color: 'yellow', fontSize: '1.1em' }} onClick={() => {
                        if (isClickableRemark !== false) {
                          window.open(
                            isClickableRemark,
                            "DescriptiveWindowName",
                            "height=700px,width=1024px,scrollbars,toolbar,status,resizable"
                          );
                        }
                      }}>
                        {props.remarks !== "" &&
                          props.remarks !== undefined &&
                          props.remarks !== null ? (
                          <>
                            <EllipsisText
                              text={remarks}
                              length={isMobile ? 28 : 42}
                              tail={"..."}
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </StyledRemarkLbl>
                    </div>
                  )}
                </StyledRemarks>
              </Grid>
            </StyledTitleWrapper>

            {watched === false || watched === undefined ? (
              <StyledContainer item={true} xs={2}>
                <div>
                  {isReadOnlyUser ? (
                    <StyledNotStartedContainer
                      item={true}
                      xs={12}
                      onClick={() => {
                        renderReadOnlyUserToast(sellerAuctionUserId);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        className="unwatch imageColor"
                      />
                    </StyledNotStartedContainer>
                  ) : auctioneerSellerUserId !== sellerAuctionUserId ? (
                    <StyledWishContainer
                      item={true}
                      xs={12}
                      onClick={() => {
                        addProductToWatch();
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        className="unwatch"
                      />
                    </StyledWishContainer>
                  ) : (
                    <StyledNotStartedContainer
                      item={true}
                      xs={12}
                      onClick={() => {
                        renderReadOnlyUserToast(sellerAuctionUserId);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        className="unwatch imageColor"
                      />
                    </StyledNotStartedContainer>
                  )}
                </div>
              </StyledContainer>
            ) : (
              <StyledContainer item={true} xs={2}>
                <div>
                  {isReadOnlyUser ? (
                    <StyledNotStartedContainer
                      item={true}
                      xs={12}
                      onClick={() => {
                        renderReadOnlyUserToast(sellerAuctionUserId);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        className="unwatch imageColor"
                      />
                    </StyledNotStartedContainer>
                  ) : auctioneerSellerUserId !== sellerAuctionUserId ? (
                    <StyledWishContainer
                      item={true}
                      xs={12}
                      onClick={() => {
                        removeProductFromList();
                      }}
                    >
                      <FontAwesomeIcon icon={faHeartProps} className="watch" />
                    </StyledWishContainer>
                  ) : (
                    <StyledWishContainer
                      item={true}
                      xs={12}
                      onClick={() => {
                        renderReadOnlyUserToast(sellerAuctionUserId);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        className="unwatch"
                      />
                    </StyledWishContainer>
                  )}
                </div>
              </StyledContainer>
            )}
          </Grid>
          <Grid container={true} spacing={0}>
            <Grid container={true} spacing={0} className="borderBottomBlue">
              <Grid container={true} spacing={0}>
                <StyledWrapper
                  item={true}
                  xs={9}
                  onClick={() => sortingFuction("caratMinimumPrice", direction)}
                >
                  <StyledLabelWrapper className="secondaryLabel fontBold">
                    {t("common:preview:productsList:startingPrice")} (
                    {t("common:preview:productsList:pct")})
                  </StyledLabelWrapper>
                  <StyledBidAmount>
                    <span className="fontBold textWrap">
                      {caratMinPrice} {conversionCaratMinPrice}
                    </span>
                  </StyledBidAmount>
                </StyledWrapper>
                <Grid
                  item={true}
                  xs={3}
                  onClick={() => sortingFuction("rapnetPercentage", direction)}
                >
                  <StyledRapOffLabelWrapper className="secondaryLabelTwo fontBold">
                    {t("common:Tender:rapOff")}
                  </StyledRapOffLabelWrapper>
                  <span
                    className="textWrap"
                    style={{ justifyContent: "center" }}
                  >
                    {rapnetPercentage === undefined || rapnetPercentage === 0
                      ? "-"
                      : rapnetPercentage}
                  </span>
                </Grid>
              </Grid>
            </Grid>
            <Grid container={true} spacing={0} className="borderBottomBlue">
              <Grid item={true} xs={3} className="borderRightBlue">
                <StyledWrapper
                  onClick={() => sortingFuction("serialNo", direction)}
                >
                  <StyledSerialNumberLabelWrapper>
                    {t("common:preview:productsList:serialNo")}
                  </StyledSerialNumberLabelWrapper>
                  <StyledValueConatiner>{serialNo}</StyledValueConatiner>
                </StyledWrapper>
                <StyledWrapper>
                  <StyledSerialNumberLabelWrapper
                    onClick={() => sortingFuction("lab", direction)}
                  >
                    {lab}
                  </StyledSerialNumberLabelWrapper>
                  <StyledValueConatiner
                    style={{ textAlign: "center", fontSize: "0.8em" }}
                  >
                    {lab !== "AGT" &&
                      lab !== "Agt" &&
                      lab !== "" &&
                      lab !== undefined ? (
                      <a
                        href="#/"
                        onClick={() =>
                          openCertificateLinkPopup(lab, certificate)
                        }
                        className="moveToLandingPageLink"
                      >
                        {certificate}
                      </a>
                    ) : (
                      <>
                        <span style={{ color: "black" }}>{certificate}</span>
                      </>
                    )}
                  </StyledValueConatiner>
                </StyledWrapper>
              </Grid>
              {mediaSection}
            </Grid>
            <Grid container={true} spacing={0}>
              <StyledWrapper item={true} xs={12}>
                <StyledLabelWrapper className="secondaryLabel fontBold">
                  {t("common:preview:productsList:preBiddingPrice")}
                </StyledLabelWrapper>
                <StyledPrebidBidAmount>
                  <PreviewPrebiding
                    {...props}
                    items={items}
                    count={0}
                    isReadOnlyUser={isReadOnlyUser}
                    apiCall={prebidCall}
                    isMobileUi={true}
                  />
                </StyledPrebidBidAmount>
              </StyledWrapper>
            </Grid>
          </Grid>
        </StyledCardContainer>
      )}
      <Menu
        keepMounted
        open={mouseState.mouseY !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          mouseState.mouseY !== null && mouseState.mouseX !== null
            ? { top: mouseState.mouseY, left: mouseState.mouseX }
            : undefined
        }
      >
        <MenuItem
          onClick={() => openDetailsView(auctionId, perId, auctionDate)}
        >
          Details
        </MenuItem>
      </Menu>
      {openReadOnlyUserToast === true && (
        <AlertReadOnlyUser
          isReadOnlyUser={isReadOnlyUser}
          isSeller={isSellerAuctionUserId}
        />
      )}
    </Grid>
  );
};

export default ProductsListGrid;
